import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { FabMenu, iconHandshake, iconHome, iconPersonAdd } from '@sauda/ui/kit';
import { useChrome } from './chrome.js';

/** The new menu: add a property, start a deal, and for an owner or manager invite someone. In the rail it is the icon button at the top. */
export function NewMenu({
  team,
  compact = false,
  labelled = false,
  below = false,
}: {
  team: boolean;
  compact?: boolean;
  labelled?: boolean;
  below?: boolean;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const chrome = useChrome();
  if (chrome.readOnly) return null;
  const items = [
    {
      key: 'property',
      label: t('today.addProperty'),
      icon: iconHome,
      onSelect: () => void navigate('/properties/new'),
    },
    {
      key: 'enquiry',
      label: t('today.newEnquiry'),
      icon: iconPersonAdd,
      onSelect: () => void navigate('/visits?tab=enquiries&enquiry=1'),
    },
    {
      key: 'deal',
      label: t('today.newDeal'),
      icon: iconHandshake,
      onSelect: () => void navigate('/deals?new=1'),
    },
    ...(team
      ? [
          {
            key: 'invite',
            label: t('today.invite'),
            icon: iconPersonAdd,
            onSelect: () => void navigate('/team'),
          },
        ]
      : []),
  ];
  return (
    <FabMenu
      label={t('today.new')}
      items={items}
      compact={compact}
      labelled={labelled}
      below={below}
    />
  );
}
